const SORT_KEY_MAP = {
    status: 'status',
    campaign_name: 'campaign_name',
    is_recurrent: 'is_recurrent',
    sent_at: 'sent_at',
    base_people: 'base_people',
    sent_total: 'sent_total',
};
export const METRIC_COLUMN_MIN_WIDTHS = {
    status: 108,
    campaign_name: 268,
    template: 90,
    is_recurrent: 180,
    sent_at: 150,
    base_people: 100,
    sent_total: 90,
};
export const CLIENT_SORTABLE_KEYS = Object.keys(SORT_KEY_MAP);
export function sanitizeSort(orderBy, map = SORT_KEY_MAP) {
    if (!orderBy)
        return '';
    const desc = orderBy.startsWith('-');
    const key = desc ? orderBy.slice(1) : orderBy;
    const mapped = map[key];
    if (!mapped)
        return '';
    return desc ? `-${mapped}` : mapped;
}
export function paginateAndSortParams(page, limit, orderBy, map = SORT_KEY_MAP) {
    const params = {};
    if (page != null)
        params.page = page;
    if (limit != null)
        params.per_page = limit;
    const sanitized = sanitizeSort(orderBy, map);
    if (sanitized)
        params.sort = sanitized;
    return params;
}
export function filtersToParams(filters) {
    const out = {};
    if (!filters)
        return out;
    Object.entries(filters).forEach(([k, v]) => {
        const str = v == null ? '' : String(v).trim();
        if (str === '')
            return;
        if (k === 'sent_at') {
            const normalizeDate = (value) => {
                const s = value.trim();
                if (!s)
                    return null;
                const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
                if (isoMatch) {
                    const [, y, m, d] = isoMatch;
                    return `${y}-${m}-${d}`;
                }
                const brMatch = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
                if (brMatch) {
                    const [, d, m, y] = brMatch;
                    return `${y}-${m}-${d}`;
                }
                return null;
            };
            const start = normalizeDate(str);
            if (start) {
                out['date[0]'] = start;
            }
            return;
        }
        if (k === 'is_recurrent') {
            const norm = str.toLowerCase();
            if (['recorrente', 'recorrentes'].includes(norm)) {
                out[k] = 'true';
                return;
            }
            if (['pontual', 'pontuais'].includes(norm)) {
                out[k] = 'false';
                return;
            }
            out[k] = str;
            return;
        }
        out[k] = str;
    });
    return out;
}
export function buildAxiosParams(opts) {
    const p1 = paginateAndSortParams(opts.page, opts.limit, opts.orderBy, opts.map || SORT_KEY_MAP);
    const p2 = filtersToParams(opts.filters);
    return { ...p1, ...p2 };
}
const STATUS_ALIASES = {
    'em envio': 'em envio',
};
export function normStatus(s) {
    const k = (s ?? '').toString().trim().toLowerCase();
    return STATUS_ALIASES[k] || k;
}
export function can(row, action) {
    if (action === 'edit' && typeof row.is_editable === 'boolean')
        return row.is_editable;
    if (action === 'delete' && typeof row.is_deletable === 'boolean')
        return row.is_deletable;
    if (action === 'finish' && typeof row.is_finishable === 'boolean')
        return row.is_finishable;
    const s = normStatus(row.status);
    if (action === 'finish')
        return ['ativa', 'em envio', 'active', 'sending'].includes(s);
    return ['rascunho', 'draft'].includes(s);
}
export function getRowId(row) {
    const v = row.id ??
        row.campaignId ??
        row.campaign_id ??
        null;
    return typeof v === 'string' || typeof v === 'number' ? v : null;
}
